export function getRootDoc() {
    return document.documentElement;
}
